/*
 * This file is generated by icons/template.js
 */
const SvgNextdoor = (props: React.SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
		<path fill="#1b8751" d="M0 5a5 5 0 0 1 5-5h14a5 5 0 0 1 5 5v14a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5z" />
		<path
			fill="#fff"
			d="M8.797 6.863V4.85H6.131v3.687l-3.124 1.964 1.414 2.251 1.71-1.073v7.46h11.748v-7.46l1.71 1.073 1.414-2.251-8.994-5.65z"
		/>
	</svg>
);
SvgNextdoor.displayName = 'iconNextdoor';
export default SvgNextdoor;
